import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { CSVLink } from "react-csv";
import toast from "react-hot-toast";
import ReportService from "../services/ReportService";
import { useBrand } from "./../helper/BrandContext";

const Feedbackrpt = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const reportService = new ReportService();
  const surveyLink = useRef(null);
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: ""
  });
  const [dialogVisible, setDialogVisible] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState({
    email: "",
    feedbackText: "",
    userName: ""
  });
  const [isSending, setIsSending] = useState(false);

  const formatDateMMDDYYYY = (date) => {
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  const navigate = useNavigate();
  const [triggerDownload, setTriggerDownload] = useState(false);

  function GetFeedbackRpt() {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    reportService
      .Feedback(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (
      (name === "FromDate" || name === "ToDate") &&
      !(value instanceof Date)
    ) {
      toast.error(
        `Please select a valid ${name === "FromDate" ? "from" : "to"} date.`
      );
      return;
    }

    if (name === "FromDate" && value > state.ToDate) {
      toast.error("From date must be less than to date.");
      return;
    }

    if (name === "ToDate" && value < state.FromDate) {
      toast.error("To date must be greater than from date.");
      return;
    }

    setState((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const FilterData = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    tableRequest.FromDate = formatDateMMDDYYYY(state.FromDate);
    tableRequest.ToDate = formatDateMMDDYYYY(state.ToDate);
    GetFeedbackRpt();
  };

  const GetReportExport = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    tableRequest.PageSize = -1;
    reportService
      .Feedback(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          setState((prevData) => ({
            ...prevData,
            allData: data.responseData,
            loading: false
          }));
          setTriggerDownload(true);
        } else {
          setState((prevData) => ({
            ...prevData,
            allData: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to export data");
      });
  };

  const searchFilter = (e) => {
    const value = e.target.value;
    setState((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    GetFeedbackRpt();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    GetFeedbackRpt();
  };

  const handleFeedbackSubmit = async () => {
    if (!selectedFeedback.email || !selectedFeedback.feedbackText) {
      toast.error("Email and feedback are required");
      return;
    }

    setIsSending(true);

    try {
      const feedbackData = {
        Email: selectedFeedback.email,
        feedback: selectedFeedback.feedbackText,
        UserName: selectedFeedback.userName
      };

      const response = await reportService.SendFeedbackToUser(feedbackData);
      
      if (response.responseCode === "200") {
        toast.success("Feedback sent successfully");
        setDialogVisible(false);
        setSelectedFeedback({
          email: "",
          feedbackText: "",
          userName: ""
        });
      } else {
        toast.error("Failed to send feedback");
      }
    } catch (error) {
      console.error("API request failed:", error);
      toast.error("Failed to send feedback");
    } finally {
        setIsSending(false);
      }
  };

  const openFeedbackDialog = (rowData) => {
    setSelectedFeedback({
      email: rowData.email,
      feedbackText: "",
      userName: rowData.username || rowData.userName || "Customer"
    });
    setDialogVisible(true);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <Button
        label="Send Feedback"
        icon="pi pi-envelope"
        className="p-button-sm p-button-info"
        onClick={() => openFeedbackDialog(rowData)}
      />
    );
  };

  // Add this function to handle text wrapping for long content
  const textBodyTemplate = (rowData, field) => {
    return (
      <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
        {rowData[field]}
      </div>
    );
  };

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
      var date = new Date();
      date.setDate(date.getDate() - 7);
      tableRequest.FromDate = date.toLocaleDateString();
      tableRequest.ToDate = new Date().toLocaleDateString();
      setState((prevData) => ({
        ...prevData,
        FromDate: date,
        ToDate: new Date()
      }));
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    if (brand) {
      tableRequest.brandId = brand;
      GetFeedbackRpt();
    }
  }, [brand]);

  useEffect(() => {
    if (triggerDownload) {
      surveyLink.current.link.click();
      setTriggerDownload(false);
    }
  }, [triggerDownload]);

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Feedback Report
        </h1>
      </div>
      <div className="date-picker-container flex items-center mb-4 md:mb-0">
        <Calendar
          value={state.FromDate || undefined}
          name="FromDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="From Date"
          className="p-inputtext-sm mr-2"
        />
        <Calendar
          value={state.ToDate || undefined}
          name="ToDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="To Date"
          className="p-inputtext-sm mr-2"
        />
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
        </div>
        <button
          type="button"
          onClick={FilterData}
          className="ml-3 mr-3 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Submit
        </button>
        <button
          target="_blank"
          disabled={!state.sales.length}
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          onClick={GetReportExport}
        >
          Export
        </button>
        <CSVLink
          hidden={true}
          data={state.allData}
          ref={surveyLink}
          filename={"Feedback Report.csv"}
        >
          Export
        </CSVLink>
      </div>
    </div>
  );

  const dialogFooter = (
    <div>
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setDialogVisible(false)}
        className="p-button-text"
        disabled={isSending}
      />
      <Button
        label={isSending ? "Sending..." : "Send"}
        icon={isSending ? "pi pi-spinner pi-spin" : "pi pi-check"}
        onClick={handleFeedbackSubmit}
        className="p-button-success"
        disabled={isSending}
      />
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <DataTable
              exportFilename="Feedback Report"
              responsive={true}
              header={header}
              globalFilter={state.globalFilter}
              emptyMessage={state.emptyMessage}
              value={state.sales}
              paginator={true}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              rows={state.rows}
              rowsPerPageOptions={[10, 50, 200, 500]}
              totalRecords={state.totalRecords}
              lazy={true}
              first={state.first}
              onPage={onPage}
              onSort={onSort}
              className="p-datatable-responsive"
              scrollable={true}
            >
              <Column
                field="qrSeqNo"
                header="Seq Number"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="username"
                header="User Name"
                sortable={false}
                style={{ width: "150px" }}
                body={(rowData) => textBodyTemplate(rowData, 'username')}
              />
              <Column
                field="mobno"
                header="Mobile Number"
                sortable={false}
                style={{ width: "120px" }}
              />
              <Column
                field="email"
                header="Email"
                sortable={false}
                style={{ width: "200px" }}
                body={(rowData) => textBodyTemplate(rowData, 'email')}
              />
              <Column
                field="feedback"
                header="Feedback"
                sortable={false}
                style={{ width: "300px" }}
                body={(rowData) => textBodyTemplate(rowData, 'feedback')}
              />
              <Column
                field="createdDate"
                header="Feedback Date"
                sortable={true}
                style={{ width: "150px" }}
              />
              <Column
                header="Send Feedback"
                body={actionBodyTemplate}
                style={{ width: "150px" }}
              />
            </DataTable>
          </div>
          <Dialog
            header="Send Feedback"
            visible={dialogVisible}
            style={{ width: "50vw" }}
            footer={dialogFooter}
            onHide={() => !isSending && setDialogVisible(false)}
            closable={!isSending}
          >
            <div className="p-field mb-3">
              <label htmlFor="userName" className="block mb-2 font-semibold">
                User Name
              </label>
              <InputText
                id="userName"
                value={selectedFeedback.userName}
                className="w-full"
                disabled
              />
            </div>
            <div className="p-field mb-3">
              <label htmlFor="email" className="block mb-2 font-semibold">
                Email
              </label>
              <InputText
                id="email"
                value={selectedFeedback.email}
                className="w-full"
                disabled
              />
            </div>
            <div className="p-field">
              <label htmlFor="feedbackText" className="block mb-2 font-semibold">
                Feedback *
              </label>
              <InputTextarea
                id="feedbackText"
                value={selectedFeedback.feedbackText}
                onChange={(e) =>
                  setSelectedFeedback({
                    ...selectedFeedback,
                    feedbackText: e.target.value
                  })
                }
                rows={5}
                className="w-full"
                placeholder="Enter your feedback message here"
                autoFocus
              />
            </div>
          </Dialog>
        </div>
      )}
    </div>
  );
};

export default Feedbackrpt;